import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const AreaHeader = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.25rem;
`;

export const CollapseHeader = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: start;
	align-items: center;
`;

export const CollapseHeaderText = styled.h6`
	margin: 0;
	padding: 0;
	padding-left: 3px;
	font-weight: 600;
`;

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1rem;
	justify-content: end;
`;

export const AreaCollapses = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

export const Title = styled.h6`
	font-weight: bold;
	margin: 0;
`;

export const AreaHeaderRight = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;

export const AreaHeaderLeft = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
`;

export const AreaPrice = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 0.5rem;
`;
